var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_4695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.725 9.28248C18.4325 8.98998 17.96 8.98998 17.6675 9.28248L14 12.9425L10.3325 9.27498C10.04 8.98248 9.56754 8.98248 9.27504 9.27498C8.98254 9.56748 8.98254 10.04 9.27504 10.3325L12.9425 14L9.27504 17.6675C8.98254 17.96 8.98254 18.4325 9.27504 18.725C9.56754 19.0175 10.04 19.0175 10.3325 18.725L14 15.0575L17.6675 18.725C17.96 19.0175 18.4325 19.0175 18.725 18.725C19.0175 18.4325 19.0175 17.96 18.725 17.6675L15.0575 14L18.725 10.3325C19.01 10.0475 19.01 9.56748 18.725 9.28248Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_4695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear1);
export default __webpack_public_path__ + "static/media/clear1.ce70d7dd91cd101e49af38bca78ce2b3.svg";
export { ForwardRef as ReactComponent };